import React from 'react';
import {MasterLayout} from 'components/layouts';
import MemberZone from './MemberZone.jsx';
import title from 'constants/TitlePages.js';
import {UserLayout} from 'components/layouts/user';
import {MyRequestContent} from 'components/users/sub-view';

class MyRequests extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    document.title = title.MyRequests;
  }

  render() {
    return (
      <MasterLayout>
        <UserLayout active="my-requests">
          <h1 className="user-header">Yêu cầu đã gửi</h1>
          <MyRequestContent/>
        </UserLayout>
      </MasterLayout>
    );
  }
}

export default MemberZone(MyRequests);



// WEBPACK FOOTER //
// ./pages/users/MyRequests.jsx